/* Winkelmand-drawer, het kleine beetje gedrag dat de server niet kan doen.

   De drawer haalt zichzelf bij elke wijziging opnieuw op bij Shopify en
   wisselt het resultaat in. Alles wat je ziet is dus server-side gerenderd
   en klopt na elke plus, min en verwijdering, zonder dat dit bestand iets
   hoeft na te rekenen. Wat hier staat is beperkt tot drie dingen die pas
   in de browser gebeuren:

   1. de ondergrens bewaken als iemand een aantal intypt in plaats van de
      knoppen te gebruiken;
   2. de ondervloer toevoegen vanuit de herinnering;
   3. het akkoordvinkje en de bestelknop op elkaar aansluiten.

   Omdat de inhoud van de drawer telkens wordt vervangen, hangt alles aan
   een gedelegeerde luisteraar op document. Luisteraars op de elementen
   zelf zouden bij de eerste verversing verdwijnen. */
(function () {
  'use strict';

  function tekst(sleutel, terugval) {
    var bron = window.SolzaCartTeksten || {};
    return bron[sleutel] || terugval;
  }

  /* ---------- 1. ondergrens bij typen ----------

     De plus- en minknoppen van het theme gebruiken stepUp en stepDown, en
     die houden zich vanzelf aan het min-attribuut. Typen doet dat niet: wie
     4 weghaalt en 1 intypt, komt onder de minimale afname uit. Daarom hier
     een klem, op change en niet op input -- tijdens het typen is het veld
     even leeg of half af, en dan zou de klem het getal onder je vingers
     vandaan veranderen. */
  document.addEventListener(
    'change',
    function (e) {
      var veld = e.target;
      if (!veld || !veld.classList || !veld.classList.contains('m-quantity__input')) return;

      var min = parseInt(veld.getAttribute('min'), 10);
      if (!min || min < 1) return;

      var waarde = parseInt(veld.value, 10);
      if (isNaN(waarde) || waarde >= min) return;

      veld.value = min;
    },
    true /* in de capture-fase, zodat de klem klaar is voordat het theme de
            nieuwe waarde naar Shopify stuurt */
  );

  /* ---------- 2. de ondervloer toevoegen ---------- */

  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('[data-solza-nudge-toevoegen]');
    if (!knop || knop.disabled) return;

    e.preventDefault();
    knop.disabled = true;
    knop.textContent = tekst('nudge_bezig', knop.textContent);

    var lichaam = {
      items: [
        {
          id: parseInt(knop.dataset.variant, 10),
          quantity: parseInt(knop.dataset.aantal, 10) || 1
        }
      ]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(lichaam)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('toevoegen mislukt');
        return r.json();
      })
      .then(function () {
        /* De drawer opnieuw laten ophalen. Daarmee verdwijnt deze
           herinnering vanzelf, want de voorwaarde eronder klopt niet meer.
           Zelf het blok weghalen zou sneller ogen maar laat de rest van de
           mand achter met verouderde bedragen. */
        var drawer = document.querySelector('m-cart-drawer');
        if (drawer && typeof drawer.onCartDrawerUpdate === 'function') {
          drawer.onCartDrawerUpdate();
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        /* Mislukt het, dan gaat de knop terug naar zijn oude staat. Een
           knop die op "bezig" blijft hangen laat de klant wachten op iets
           dat niet meer komt. */
        knop.disabled = false;
        knop.textContent = tekst('nudge_knop', 'Toevoegen');
      });
  });

  /* ---------- 2b. een samenstelling in één keer verwijderen ----------

     Een deur met glas ligt als twee regels in de mand, gekoppeld met de
     verborgen eigenschap _config. De verwijderknop van het theme haalt één
     regel weg; hier vangen we die klik af op de hoofdregel en zetten we
     alle regels met dezelfde _config in één verzoek op nul.

     Waarom in één verzoek: bij twee losse verzoeken schuiven de
     regelnummers na de eerste verwijdering op, en dan haalt de tweede de
     verkeerde regel weg. update.js accepteert de regelsleutel als naam, en
     die verschuift niet.

     De bijlage heeft zelf geen verwijderknop, dus die kant hoeft niet
     afgevangen te worden. */
  document.addEventListener(
    'click',
    function (e) {
      var knop = e.target.closest && e.target.closest('m-cart-remove-button');
      if (!knop) return;

      var regel = knop.closest('[data-solza-config]');
      if (!regel) return;

      var config = regel.getAttribute('data-solza-config');
      if (!config) return;

      var groep = [].slice.call(document.querySelectorAll('[data-solza-config="' + config + '"]'));
      var updates = {};
      groep.forEach(function (el) {
        var sleutel = el.getAttribute('data-solza-sleutel');
        if (sleutel) updates[sleutel] = 0;
      });

      /* Eén regel in de groep is geen groep: laat het theme zijn werk doen.
         Dat gebeurt als het glas al los is weggehaald, of als de mand op de
         pagina en in de lade tegelijk staat en we hier de verkeerde helft
         te pakken hebben. */
      if (Object.keys(updates).length < 2) return;

      e.preventDefault();
      e.stopPropagation();

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('verwijderen mislukt');
          return r.json();
        })
        .then(function (mand) {
          /* De lade en de winkelmandpagina halen zichzelf allebei opnieuw
             op zodra ze horen dat de mand is veranderd. Zelf de regels uit
             de DOM halen zou sneller ogen maar laat de subtotalen staan. */
          var lade = document.querySelector('m-cart-drawer');
          if (lade && typeof lade.onCartDrawerUpdate === 'function') {
            lade.onCartDrawerUpdate();
          }
          if (window.MinimogEvents && window.MinimogTheme) {
            window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, mand);
          } else if (!lade) {
            window.location.reload();
          }
        })
        .catch(function () {
          window.location.reload();
        });
    },
    true /* capture: vóór de eigen klikafhandeling van m-cart-remove-button */
  );

  /* ---------- 2c. het aantal van een samenstelling ----------

     Twee deuren met glas zijn twee keer glas. De hoofdregel houdt zijn
     aantalkiezer, de bijlage niet, dus zonder deze regel blijft het glas
     op één staan terwijl er twee deuren besteld worden -- en dat merkt
     niemand tot de bestelling binnenkomt.

     Beide regels gaan in hetzelfde verzoek mee, om dezelfde reden als bij
     het verwijderen: twee losse verzoeken laten de mand tussendoor in een
     stand achter die niet klopt. */
  document.addEventListener(
    'change',
    function (e) {
      var veld = e.target;
      if (!veld || !veld.classList || !veld.classList.contains('m-quantity__input')) return;

      var regel = veld.closest('[data-solza-config]');
      if (!regel) return;

      /* Alleen de hoofdregel: de bijlage heeft geen eigen kiezer, maar op
         de winkelmandpagina staat die van de vendorsnippet er nog wel --
         verborgen met CSS, en verborgen velden kunnen alsnog wijzigen. */
      if (regel.classList.contains('solza-cartregel--bijlage')) return;
      if (regel.classList.contains('solza-cartkoppel--bijlage')) return;

      var config = regel.getAttribute('data-solza-config');
      var aantal = parseInt(veld.value, 10);
      if (!config || isNaN(aantal) || aantal < 1) return;

      var updates = {};
      [].slice.call(document.querySelectorAll('[data-solza-config="' + config + '"]')).forEach(function (el) {
        var sleutel = el.getAttribute('data-solza-sleutel');
        if (sleutel) updates[sleutel] = aantal;
      });
      if (Object.keys(updates).length < 2) return;

      e.stopPropagation();

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('bijwerken mislukt');
          return r.json();
        })
        .then(function (mand) {
          var lade = document.querySelector('m-cart-drawer');
          if (lade && typeof lade.onCartDrawerUpdate === 'function') lade.onCartDrawerUpdate();
          if (window.MinimogEvents && window.MinimogTheme) {
            window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, mand);
          } else if (!lade) {
            window.location.reload();
          }
        })
        .catch(function () {
          window.location.reload();
        });
    },
    true /* capture: vóór de eigen afhandeling van de mand */
  );

  /* ---------- 2d. de winkelmandpagina bijschaven ----------

     De lade tekent zijn regels zelf, dus daar staat alles al goed. De
     winkelmandpagina gebruikt de vendorsnippet cart-line-item, en die
     blijft ongewijzigd -- hij wordt bij een theme-update overschreven.
     Twee dingen zijn daar met CSS niet te doen, en die gebeuren hier:

     1. de naam van een bijregel vervangen. "Toeslag glas Satijn vlak glas
        voor New York" is een naam voor de administratie; de klant leest
        "Glas: Satijn vlak". De leesbare naam staat al klaar in
        data-solza-naam, gemaakt door hetzelfde snippet dat de lade
        gebruikt;
     2. optieregels weglaten die niets zeggen. Welke wél iets zeggen staat
        in data-solza-opties; regels met een ander label gaan weg. Zonder
        het attribuut blijft alles staan.

     De pagina vervangt bij elke wijziging zijn regels, dus dit draait
     opnieuw na elke verversing. */
  function schaafWinkelmand() {
    document.querySelectorAll('[data-solza-naam]').forEach(function (wikkel) {
      var naam = wikkel.getAttribute('data-solza-naam');
      var titel = wikkel.querySelector('.m-cart-item__title');
      if (naam && titel && titel.textContent.trim() !== naam) titel.textContent = naam;
    });

    document.querySelectorAll('[data-solza-opties]').forEach(function (wikkel) {
      var toon = (wikkel.getAttribute('data-solza-opties') || '').split('|').filter(Boolean);
      wikkel.querySelectorAll('.m-cart-item__option').forEach(function (regel) {
        var label = (regel.textContent || '').split(':')[0].trim();
        if (!label) return;
        regel.hidden = toon.indexOf(label) === -1;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schaafWinkelmand);
  } else {
    schaafWinkelmand();
  }

  /* Na elke wijziging tekent de pagina zijn regels opnieuw. De gebeurtenis
     komt voordat de nieuwe HTML in de DOM staat, vandaar de tik erachter. */
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.MinimogEvents || !window.MinimogTheme) return;
    window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, function () {
      setTimeout(schaafWinkelmand, 60);
    });
  });

  /* ---------- 3. akkoordvinkje en bestelknop ---------- */

  function zetKnopstand(vinkje) {
    var doos = vinkje.closest('[data-solza-akkoord]');
    if (!doos) return;
    var wikkel = doos.parentElement;
    var knop = wikkel && wikkel.querySelector('[data-solza-bestel]');
    if (!knop) return;

    if (vinkje.checked) {
      knop.classList.remove('solza-cartfoot__bestel--wacht');
      knop.removeAttribute('aria-disabled');
      doos.classList.remove('solza-cartfoot__akkoord--vraagt');
    } else {
      knop.classList.add('solza-cartfoot__bestel--wacht');
      knop.setAttribute('aria-disabled', 'true');
    }
  }

  document.addEventListener('change', function (e) {
    var vinkje = e.target.closest && e.target.closest('[data-solza-akkoord-vinkje]');
    if (vinkje) zetKnopstand(vinkje);
  });

  /* Een te vroege klik. De knop is bewust niet disabled: uitgeschakeld
     vertelt niets en is met een schermlezer niet eens te vinden. Nu licht
     het vinkje op en springt de focus erheen, zodat duidelijk is wat er nog
     moet gebeuren. Geen browsermelding: die staat buiten de pagina en zegt
     niet waar je moet kijken. */
  document.addEventListener(
    'click',
    function (e) {
      var knop = e.target.closest && e.target.closest('[data-solza-bestel]');
      if (!knop || knop.getAttribute('aria-disabled') !== 'true') return;

      e.preventDefault();
      e.stopPropagation();

      var wikkel = knop.closest('.solza-cartfoot__knopwikkel');
      var doos = wikkel && wikkel.parentElement.querySelector('[data-solza-akkoord]');
      if (!doos) return;

      doos.classList.remove('solza-cartfoot__akkoord--vraagt');
      void doos.offsetWidth;
      doos.classList.add('solza-cartfoot__akkoord--vraagt');

      /* De focus naar het vinkje zelf. Dat staat onzichtbaar maar wel in
         de tabvolgorde, dus focus() werkt en de getekende doos licht mee
         op via focus-visible. Lukt het niet, dan is er niets kapot: de
         doos licht sowieso al op. */
      var vinkje = doos.querySelector('[data-solza-akkoord-vinkje]');
      if (vinkje) {
        try {
          vinkje.focus({ preventScroll: false });
        } catch (fout) {
          /* oudere browsers kennen de optie niet */
          vinkje.focus();
        }
      }
    },
    true
  );
})();
